import { useHttp } from "../http/useHttp";
import { useAxiosMutation } from "../http/useAxiosMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type SetAchConfigurationOperation =
  paths["/dashboard/users/{api_token_uuid}/set-ach-configuration"]["post"];
type SetAchConfigurationRequestBody =
  SetAchConfigurationOperation["requestBody"]["content"]["application/json"];
type SetAchConfigurationResponse =
  SetAchConfigurationOperation["responses"][200]["content"]["application/json"];
type SetAchConfigurationPath = SetAchConfigurationOperation["parameters"]["path"];

export type ISetAchConfigurationInput = SetAchConfigurationRequestBody & {
  user_shared_uuid: SetAchConfigurationPath["api_token_uuid"];
};

export const useUserSetAchConfiguration = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMutation<
    SetAchConfigurationResponse,
    ISetAchConfigurationInput
  >({
    mutationKey: ["user-set-ach-configuration"],
    mutationFn: ({ user_shared_uuid, ...input }) =>
      client.post(`/users/${user_shared_uuid}/set-ach-configuration`, input),
  });

  useDefaultError(error, "Failed to set ACH configuration");

  return { setAchConfiguration: mutate, isPending, status, data, error };
};

export type UseUserSetAchConfigurationReturn = ReturnType<typeof useUserSetAchConfiguration>;
